import React from 'react';

export function SolventLogo() {
  return <h1 className="logo">Solvent</h1>;
}
